const multipliers = {
  1: 1,
  2: 60,
  3: 3600,
  4: 86400,
  5: 604800,
  6: 2592000,
  7: 31104000,
};

export function getSeconds(timeValue, timeUnit) {
  return +timeValue * multipliers[timeUnit];
}

export function secondsToUnit(timeValue, timeUnit) {
  return +timeValue / multipliers[timeUnit];
}

export function convertTime(timeValueInSecs) {
  var seconds = Number(timeValueInSecs);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);

  var dDisplay =
    d > 0 ? d + (d == 1 ? " day, " : " days") + (h > 0 ? ", " : "") : "";
  var hDisplay =
    h > 0 ? h + (h == 1 ? " hour, " : " hours") + (m > 0 ? ", " : "") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " minute" : " minutes") : "";

  return dDisplay + hDisplay + mDisplay;
}

export const formatTime = (timeStr) => {
  if (!timeStr) return "";
  const value = timeStr.slice(0, -1);
  const unit = timeStr.slice(-1);
  switch (unit) {
    case "m":
      return `${value} Minute`;
    case "d":
      return `${value} Day`;
    case "h":
      return `${value} Hour`;
    default:
      return timeStr;
  }
};

export const parseTimeUnit = (v) => {
  if (!v) return { num: "", unit: "" };

  const num = parseInt(v);
  const letter = v.replace(/\d+/g, "").toLowerCase();

  const unitMap = {
    d: "days",
    h: "hours",
    m: "minute",
  };

  return { num, unit: unitMap[letter] || "" };
};
